// Single source of truth for the support contact address.
// Update here only — all UI references must import from this module.
export const SUPPORT_EMAIL = 'support@iv-talent.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
